import type { z } from "zod";

import { SelectIcon } from "@/components/icons/select-icon";
import { RichText } from "@/components/rich-text";
import { cn } from "@/lib/utils";
import type { customCardSchema } from "@/schemas";

export function WithLeftBorder({
  className,
  ...props
}: z.infer<typeof customCardSchema> & { className?: string }) {
  const { title, richTextTitle, icon, description, alignment } = props;

  return (
    <article
      className={cn(
        "border-t-grey-100 lg:border-l-grey-100 mx-auto flex w-full max-w-[444px] flex-col gap-6 self-stretch overflow-hidden border border-transparent p-0 pt-6 lg:max-w-none lg:gap-8 lg:border-l lg:border-t-transparent lg:pt-0 lg:pl-5",
        { "lg:items-center": alignment === "center" },
        className
      )}
    >
      <div className="flex items-center gap-8">
        {icon && <SelectIcon id={icon} className="size-14" alt={icon} />}
        {richTextTitle ? (
          <span className="text-heading-20 block max-w-[168px] lg:hidden">
            <RichText value={richTextTitle} />
          </span>
        ) : (
          <span className="text-heading-20 block max-w-[168px] lg:hidden">
            {title}
          </span>
        )}
      </div>
      <div
        className={cn("flex flex-col gap-1", {
          "lg:text-center": alignment === "center",
        })}
      >
        {richTextTitle ? (
          <span className="text-heading-24 hidden lg:block">
            <RichText value={richTextTitle} />
          </span>
        ) : (
          <span className="text-heading-24 hidden lg:block">{title}</span>
        )}
        {description && (
          <p className="text-body text-grey-900 lg:text-body-md max-w-[370px]">
            {description}
          </p>
        )}
      </div>
    </article>
  );
}
